import React, {memo} from 'react';

import find from 'lodash/find';

import {getObjectName} from 'app/utils/fallbacks';

import {SimpleItemPickerItem} from './SimpleItemPickerItem';

import type {BaseItemPickerObject} from './SimpleItemPickerList';

const genericItemName = (obj: BaseItemPickerObject) =>
  getObjectName(obj, null, true);

type Props<T> = {
  allResults: Array<T>;
  selected: Array<T>;
  setSelected: (
    selected: Array<T> | ((selected: Array<T>) => Array<T>)
  ) => unknown;
  addItemProps: (item: T) => {
    disabledText?: string;
  };
  showDescription: boolean;
  resultsFingerprint: number;
};

export const SimpleItemRenderItems = memo<Props<any>>(
  <T extends BaseItemPickerObject>({
    allResults,
    selected,
    setSelected,
    addItemProps,
    showDescription,
  }: Props<T>) => (
    <>
      {allResults.length
        ? allResults.map((item) => (
            <SimpleItemPickerItem
              getFallback={genericItemName}
              showDescription={showDescription}
              key={item.url}
              item={item}
              setSelected={setSelected}
              isSelected={
                find(selected, {
                  url: item.url,
                }) != null
              }
              {...addItemProps(item)}
            />
          ))
        : null}
    </>
  ),
  (prevProps: Props<any>, nextProps: Props<any>) =>
    prevProps.resultsFingerprint === nextProps.resultsFingerprint &&
    prevProps.allResults.length === nextProps.allResults.length &&
    prevProps.selected.length === nextProps.selected.length
);
